
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{staticClass:"active-highlight",attrs:{"d":"M22.151 15.077a.598.598 0 00-.598.597v5.308a1.795 1.795 0 01-1.793 1.793H2.99a1.795 1.795 0 01-1.794-1.793V5.405A1.795 1.795 0 012.99 3.612h5.307a.598.598 0 100-1.195H2.989A2.992 2.992 0 000 5.405v15.577a2.992 2.992 0 002.989 2.988H19.76a2.992 2.992 0 002.989-2.988v-5.308a.598.598 0 00-.598-.597z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M22.512.879a2.69 2.69 0 00-3.804 0L8.044 11.543a.598.598 0 00-.153.263l-1.402 5.063a.598.598 0 00.735.735l5.063-1.402a.6.6 0 00.263-.154L23.213 5.384a2.693 2.693 0 000-3.804l-.7-.701zM9.347 11.93l8.727-8.728 2.815 2.815-8.728 8.728-2.814-2.815zm-.563 1.128l2.25 2.25-3.111.861.861-3.11zm13.584-8.52l-.634.634-2.815-2.815.635-.634a1.494 1.494 0 012.113 0l.701.702c.583.584.583 1.53 0 2.113z","fill":"#00003C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    